import React from 'react';
import { useDispatch } from 'react-redux';
import { StackingAlertBanner } from '@saviynt/design-system';

import { useTypedSelector } from '../hooks';
import {
  alertQueueActions,
  type AlertQueueState,
  type QueuedAlert,
} from '../store/alertQueueSlice';
import { type RootState } from '../types';

interface BannerManagerProps {
  className?: string;
}

/**
 * BannerManager
 * @description Renders queued alert banners from the centralized alert queue.
 */
function BannerManager({
  className,
}: BannerManagerProps): React.ReactElement | null {
  const dispatch = useDispatch();
  const alertQueue = useTypedSelector(
    (s: RootState) => s.aag.alertQueue as unknown
  ) as AlertQueueState;
  const { queue } = alertQueue;

  if (!Array.isArray(queue) || queue.length === 0) {
    return null;
  }

  return (
    <>
      {queue.map((a: QueuedAlert) => (
        <StackingAlertBanner
          key={a.id}
          className={className}
          kind={a.kind}
          colorTheme={a.colorTheme}
          title={a.title}
          description={a.description}
          isVisible
          shouldAutoDismiss
          autoDismissDelay={a.autoDismissDelay ?? 5000}
          onCancel={() => dispatch(alertQueueActions.markShown(a.id))}
        />
      ))}
    </>
  );
}

BannerManager.defaultProps = {
  className: '',
};

export default BannerManager;
